import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayPopper from 'cityads-v3/components/ClickAwayPopper/ClickAwayPopper'
import Typography from '@material-ui/core/Typography';

import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';

import NumberFormat, { FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat';
import Credits from 'cityads-v3/containers/webmaster/profile/Credits';

import {
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth';

import classes from './HeaderToolbar.scss';

const ALLOWED_ROLES = [USER_ROLE_CODE_WEBMASTER];

@withRouter
@connect(
  state => ({
    user: state.auth.user,
    balance: state.auth.balance || {},
    isMobile: state.app.isMobile,
    needDocumentForPayment: state.header.needDocumentForPayment,
  })
)
@withTranslation(['main'], { i18n, wait: false })
export default class HeaderCredits extends Component {

  static propTypes = {
    user: PropTypes.object,
    authLocation: PropTypes.string,
    isMobile: PropTypes.bool,
    needDocumentForPayment: PropTypes.bool,
  }

  state = {
    open: false,
  }

  componentWillUnmount() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  anchorEl = createRef()

  handleClick = (event) => {
    event.preventDefault();
    this.setState({
      open: true
    });
  }

  closeTimeout = null

  handleRequestClose = () => {
    this.closeTimeout = setTimeout(() => {
      this.setState({
        open: false,
      });
    });
  }

  render() {
    const { user, balance, isMobile, t, needDocumentForPayment } = this.props;
    const show = user && ALLOWED_ROLES.indexOf(user.user_role_code) !== -1;

    if (!show) {
      return null;
    }

    if (isMobile) {
      return (
        <Tooltip title={t('profile.credits')}>
          <IconButton component={Link} to={'/publisher/profile/credits'}>
            <Badge
              badgeContent = {'!'}
              color        = "primary"
              invisible    = {!needDocumentForPayment}
            >
              <AccountBalanceWalletOutlinedIcon className={classes.headerIcon} />
            </Badge>
          </IconButton>
        </Tooltip>
      );
    }

    return (
      <>
        <span
          ref        = {this.anchorEl}
          onClick    = {this.handleClick}
          className  = {classNames(classes.item, classes.dropdownItem, {
            [classes.dropdownItemOpen]: this.state.open
          })}
        >
          <Badge
            badgeContent = {'!'}
            color        = "primary"
            invisible    = {!needDocumentForPayment}
            className    = {classNames(classes.headerIcon, classes.dropdownIcon)}
          >
            <AccountBalanceWalletOutlinedIcon />
          </Badge>
          <span className={classes.dropdownItemText}>
            <Typography color="textPrimary" variant="caption">
              <NumberFormat
                number={balance.available}
                format={FORMAT_CURRENCY}
                currency={balance.currency}
              />
            </Typography>
          </span>
          <KeyboardArrowDownOutlinedIcon className={classes.arrowDown} />
        </span>
        <ClickAwayPopper
          className = {classes.dropdownItemPopover}
          open      = {this.state.open}
          anchorEl  = {this.anchorEl.current}
          placement = {'bottom-end'}
          onClose   = {this.handleRequestClose}
        >
          <Credits onClose={this.handleRequestClose} />
        </ClickAwayPopper>
      </>
    );
  }
}
